/* global Swiper */
(function () {
  window.quickAddDrawerSwiper = function (
    swiperSelector,
    slidesPerView, // 'auto' for 300px slides + peek
    spaceBetween, // 4
    nextEl, // optional (ignored if missing)
    prevEl, // optional (ignored if missing)
    scrollbarEl // keep for draggable bar
  ) {
    if (!window.Swiper) {
      console.error('Swiper not loaded');
      return null;
    }
    var cfg = {
      slidesPerView: slidesPerView,
      spaceBetween: spaceBetween,
      freeMode: { enabled: true, momentum: true, momentumRatio: 1, momentumVelocityRatio: 1 },
      resistanceRatio: 0.85,
      speed: 400,
      grabCursor: true,
      observer: true,
      observeParents: true,
      watchOverflow: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
        releaseOnEdges: true,
        sensitivity: 1,
        eventsTarget: swiperSelector,
      },
    };

    if (scrollbarEl && document.querySelector(scrollbarEl)) {
      cfg.scrollbar = { el: scrollbarEl, draggable: true, hide: false };
    }
    if (nextEl && prevEl && document.querySelector(nextEl) && document.querySelector(prevEl)) {
      cfg.navigation = { nextEl: nextEl, prevEl: prevEl };
    }
    return new Swiper(swiperSelector, cfg);
  };
})();
